import { createSlice } from "@reduxjs/toolkit";
import * as selectors from "./selectors";
import {
  NotificationState,
  SetFilterType,
  SetIsNotificationDialogOpen,
} from "./interfaces";
import * as extraActions from "../../extra-actions";
import * as sagas from "./sagas";

const initialState: NotificationState = {
  list: [],
  notificationsCount: 0,
  isNotificationDialogOpen: false,
  filterType: "Produzione",
};

export const notificationStore = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setIsNotificationDialogOpen: (
      state,
      action: SetIsNotificationDialogOpen,
    ) => {
      state.isNotificationDialogOpen = action.payload;
    },
    setFilterType: (state, action: SetFilterType) => {
      state.filterType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(extraActions.postNotifications.success, (state, action) => {
      state.list = state?.list ?? [];
      state.list.push(action.payload.data.notification);
    });
    builder.addCase(
      extraActions.getMerchantsNotificationsByMerchantId.success,
      (state, action) => {
        state.list = action.payload.data.notifications;
        state.notificationsCount = action.payload.data.notificationsCount;
      },
    );
    builder.addCase(extraActions.appStartup, (state) => {
      state.isNotificationDialogOpen = initialState.isNotificationDialogOpen;
    });
    builder.addCase(extraActions.clearSession, (state, action) => {
      Object.assign(state, initialState);
    });
  },
});

export { selectors, sagas };
